export default {"src":"/_next/static/media/button-carousel-left.611da90e.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};